export default __webpack_public_path__ + "static/Ask-c8af33464a6c3c1f5a04e949daa3584d.webp";